export default "__VITE_ASSET__48cf7365__"